export const APP_CONFIG = {
    URL: {
      apiBasePath: "http://eccoplay365.com/",
    },
  };
  
  